// import { stores } from "../stores";

type ChannelPlaceholder = '%CHANNEL_A%' | '%CHANNEL_B%' | '%CHANNEL_C%' | '%CHANNEL_D%';

export function replacePlaceholders(s: string): string {
    // const chanOffset = stores.memory.getGlobalParamValue("CHAN_OFFSET");
    const chanOffset = 0;
    
    const replacements: Record<ChannelPlaceholder, string> = {
        '%CHANNEL_A%': (1 + chanOffset).toString(10),
        '%CHANNEL_B%': (2 + chanOffset).toString(10),
        '%CHANNEL_C%': (3 + chanOffset).toString(10),
        '%CHANNEL_D%': (4 + chanOffset).toString(10)
    };

    return s.replace(/%CHANNEL_[A-D]%/g, (match): string => {
        return (match in replacements) ? replacements[match as ChannelPlaceholder] : match;
    });
}